import React from 'react';
import { Button, FormControl } from '@material-ui/core';
import { FormField, SwitchButton } from '@iris-platform/iris-react-ui';
import withStyles from '@material-ui/core/styles/withStyles';
import classNames from 'classnames';
// import Call from '@material-ui/icons/Call';
// import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import Details from '@material-ui/icons/Details';
import Typography from '@material-ui/core/Typography';
import Panel from '../../../components/Panel';


const styles = theme => ({
  root: {
    opacity: '1',
    backgroundColor: '#fff',
    marginTop: '0 !important',
    border: '1px solid #ccc',
    '&:focus-within': {
      border: '1px solid #66afe9',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
  cardRoot: {
    overflow: 'auto',
  },
  panelHeader: {
    position: 'relative',
  },
  title: {
    display: 'block',
  },
  btn: {
    marginTop: '20px',
  },
  formControl: {
    margin: theme.spacing.unit,
    width: '100%',
    flexDirection: 'row',
    fontSize: '14px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
  },
  formFieldWrapper: {
    width: 350,
    display: 'inline-block',
    margin: '0 10px',
  },
  searchBtn: {
    width: 200,
    textAlign: 'center',
    marginLeft: '30px',
    marginTop: '-8px',
  },
  healthIndicesWrapper: {
    margin: '10px 5px',
    textAlign: 'right',
  },

  selectDropdown: {
    display: 'inline-block',
    width: 350,
    margin: '0 10px',
  },
  search: {
    padding: 0,
  },
  searchIcon: {
    top: '10px',
    right: '4px',
    color: '#ccc',
  },
  searchInput: {
    border: '1px solid #ccc',
  },
  iconStyles: {
    fill: '#1682bc',
  },
});


const GET_CALL_STATISTICS_ALL = gql`
{
  getCallServicesHealth {
    env,
    servertype,
    avg,
    time_bucket,
    objectId,
    createdAt,
    updatedAt
}
}
`;

class ClientTokenSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { props } = this;
    const {
      classes,
    } = props;
    return (
      <div className={classes.pageWrapper}>

        <Panel
          id="clientTokenExpirationTimePanel"
          title={<div>Client Token Expiration Time</div>}
          classes={{ title: classes.title, cardRoot: classes.cardRoot }}
          avatar={<Details className={classNames(classes.iconStyles)} />}
        >
          <div className={classes.searchWrapper}>

            <FormControl className={classes.formControl}>

              <FormField label="Token expiration in minutes" value="240" />
              <Button className={classes.searchBtn}>Update</Button>

            </FormControl>
          </div>
        </Panel>

        <Panel
          id="clientTokenScopesPanel"
          title={<div>Client Token Scopes</div>}
          classes={{ title: classes.title, cardRoot: classes.cardRoot }}
          avatar={<Details className={classNames(classes.iconStyles)} />}
        >
          <div className={classes.searchWrapper}>

            <Typography variant="display3" gutterBottom>Client Token Scopes</Typography>
            <SwitchButton checked>irisbaseclient</SwitchButton>
            <SwitchButton checked>ids</SwitchButton>
            <SwitchButton checked={false}>eks:read</SwitchButton>
            <SwitchButton checked={false}>eks:write</SwitchButton>

          </div>
        </Panel>

      </div>
    );
  }
}

export default withStyles(styles)(ClientTokenSettings);
